import React from 'react'

const Footer = () => {
  return (
    <footer className="footer">
      <p>Created with &#x1F499; by Łukasz Szymański</p>
    </footer>
  )
}

export default Footer
